import axios from "axios";
import {
    salespersonMonthlySalesStatsApi,
    staffDashboardStatsApi,
    b2cSalespersonDailyCallStatsApi,
} from "../constants/apis";
import { getUserId, getUserToken } from "../helpers/local_storage_helpers";

const authConfig = () => ({
    headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${getUserToken()}`,
    },
});

export const getStaffDashboardHome = async () => {
    return axios.get(staffDashboardStatsApi, authConfig());
};

export const getSalespersonMonthlySalesStats = async () => {
    return axios.get(salespersonMonthlySalesStatsApi + getUserId(), authConfig());
};

const getTodayStr = () => new Date().toISOString().slice(0, 10);

export const getTodayCallStats = async () => {
    return getTodayRecord();
};

const getTodayRecord = async () => {
    const today = getTodayStr();
    const res = await axios.get(
        `${b2cSalespersonDailyCallStatsApi}?sales_person=${getUserId()}&date=${today}`,
        authConfig()
    );
    const results = res.data?.results ?? res.data;
    if (!Array.isArray(results) || results.length === 0) return null;
    // Strictly validate the date on the returned record to avoid reusing
    // a stale record ID from a previous day if the backend filter misbehaves.
    const record = results[0];
    return record?.date === today ? record : null;
};

export const postStaffClockIn = async () => {
    const now = new Date();
    const clockInTime = now.toTimeString().slice(0, 8);
    const record = await getTodayRecord();

    if (record) {
        return axios.patch(
            `${b2cSalespersonDailyCallStatsApi}${record.id}/`,
            { clock_in_time: clockInTime },
            authConfig()
        );
    }
    return axios.post(
        b2cSalespersonDailyCallStatsApi,
        { sales_person: getUserId(), date: getTodayStr(), clock_in_time: clockInTime },
        authConfig()
    );
};

export const postStaffClockOut = async () => {
    const now = new Date();
    const clockOutTime = now.toTimeString().slice(0, 8);
    const record = await getTodayRecord();

    if (record) {
        return axios.patch(
            `${b2cSalespersonDailyCallStatsApi}${record.id}/`,
            { clock_out_time: clockOutTime },
            authConfig()
        );
    }
    return axios.post(
        b2cSalespersonDailyCallStatsApi,
        { sales_person: getUserId(), date: getTodayStr(), clock_out_time: clockOutTime },
        authConfig()
    );
};
